export const TBI_DEFAULT_INTEREST = 15.9
export const TBI_MAX_AUTO_LOAN_AMOUNT = 15000
export const TBI_MIN_AUTO_LOAN_AMOUNT = 500
export const TBI_MAX_GENERIC_LOAN_AMOUNT = 10000
export const TBI_MIN_GENERIC_LOAN_AMOUNT = 300

export enum TbiLoanType {
  AUTO = 'auto-loan',
  CONSUMER = 'consumer-loan'
}
